import { render, staticRenderFns } from "./OrderModal.vue?vue&type=template&id=43803aed&scoped=true"
import script from "./OrderModal.vue?vue&type=script&lang=ts"
export * from "./OrderModal.vue?vue&type=script&lang=ts"
import style0 from "./OrderModal.vue?vue&type=style&index=0&id=43803aed&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43803aed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43803aed')) {
      api.createRecord('43803aed', component.options)
    } else {
      api.reload('43803aed', component.options)
    }
    module.hot.accept("./OrderModal.vue?vue&type=template&id=43803aed&scoped=true", function () {
      api.rerender('43803aed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/refund-consign/components/OrderModal.vue"
export default component.exports